import { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import ThemeToggle from '@/components/ThemeToggle';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

function InterviewCompletedPage({ onRedirect }) {
  const [countdown, setCountdown] = useState(10);
  const progress = (10 - countdown) * 10;

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      onRedirect();
    }, 10000);

    const countdownTimer = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => {
      clearTimeout(redirectTimer);
      clearInterval(countdownTimer);
    };
  }, [onRedirect]);

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-gradient-to-br from-primary/5 via-background to-background px-4 py-10">
      <div className="absolute right-4 top-4">
        <ThemeToggle size="small" />
      </div>
      <Card className="w-full max-w-lg text-center shadow-lg">
        <CardHeader className="items-center space-y-4">
          <CheckCircle2 className="h-20 w-20 text-success drop-shadow-sm" aria-hidden />
          <CardTitle className="text-3xl">Thank you!</CardTitle>
          <CardDescription className="text-base leading-relaxed">
            You have completed the interview. Your responses are submitted for analysis. You will be notified of
            results.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-sm text-muted-foreground">
            Redirecting to your dashboard in {countdown} second{countdown !== 1 ? 's' : ''}…
          </p>
          <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full rounded-full bg-primary transition-all duration-1000 ease-linear"
              style={{ width: `${progress}%` }}
            />
          </div>
          <button
            type="button"
            onClick={onRedirect}
            className="text-sm font-medium text-primary underline-offset-4 hover:underline"
          >
            Go to dashboard now
          </button>
        </CardContent>
      </Card>
    </div>
  );
}

export default InterviewCompletedPage;
